import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import Loader from '../../components/Loader';
import {
  Bullet,
  Form, Container, Divider, Footer, Spacer, SubmitArea,
} from './styles';
import useAuth from '../../hooks/useAuth';

export default function SignInPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { handleAuthenticate, isLoading, authenticationError } = useAuth();

  function handleSubmit(event) {
    event.preventDefault();
    handleAuthenticate({ email, password });
  }

  return (
    <Container>
      <h1>Entrar</h1>
      <Form onSubmit={(event) => handleSubmit(event)}>
        <Input
          placeholder="E-mail"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <Input
          placeholder="Senha"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        {isLoading ? (
          <>
            <Spacer />
            <Loader />
          </>
        ) : (
          <SubmitArea>
            {authenticationError && <span>{authenticationError}</span>}
            <Button type="submit">Entrar</Button>
          </SubmitArea>
        )}
        <Divider />
        <Footer>
          <Link to="/forgot-password">Esqueci minha senha</Link>
          <Bullet />
          <Link to="/sign-up">Criar minha conta</Link>
        </Footer>
      </Form>
    </Container>

  );
}
